import ContentLoader from 'react-content-loader';
import React from 'react';
import { BackgroundPaper } from '@ds/react-components';
import { styled, Typography } from '@material-ui/core';

export const AccountName = styled((props) => (
  <Typography variant={'h3'} {...props} />
))(({ theme }) => ({
  marginTop: '18px',
  color: theme.palette.common.black,
}));

export const Paper = styled(BackgroundPaper)({
  maxWidth: '910px',
  minHeight: '50px',
  marginTop: '18px',
  height: 'fit-content',
});

export const PaperHeader = styled('div')(({ theme }) => ({
  padding: '18px 32px',
  borderBottom: `1px solid ${theme.palette.common.athensGray}`,
  textAlign: 'left',
  color: theme.palette.common.black,
  fontWeight: 'normal',
}));

export const PaperBody = styled('div')({
  padding: '18px 32px',
  display: 'flex',
  flexDirection: 'column',
});

export const PaperHeaderText = styled((props) => (
  <Typography variant={'h4'} {...props} />
))({
  fontWeight: '400',
});

export const LoaderHeader = (props) => (
  <ContentLoader
    speed={2}
    width={140}
    height={20}
    viewBox="0 0 140 20"
    style={{ width: '140px', height: '20px' }}
    {...props}>
    <rect x="0" y="1" rx="6" ry="6" width="140" height="20" />
  </ContentLoader>
);

export const CancellationLoaderContainer = styled('div')(({ theme }) => ({
  maxWidth: '280px',
  [theme.breakpoints.up('sm')]: {
    maxWidth: '400px',
  },
}));

// created at - http://danilowoz.com/create-content-loader/
export const CancellationLoader = (props) => (
  <ContentLoader
    speed={2}
    width={400}
    height={233}
    viewBox="0 0 400 233"
    style={{ width: '100%', height: '233px' }}
    {...props}>
    <circle cx="18" cy="47" r="16" />
    <rect x="43" y="38" rx="5" ry="5" width="240" height="16" />
    <rect x="2" y="0" rx="6" ry="6" width="160" height="16" />
    <rect x="-1" y="176" rx="6" ry="6" width="240" height="16" />
    <rect x="-3" y="203" rx="6" ry="6" width="390" height="26" />
    <circle cx="18" cy="92" r="16" />
    <rect x="41" y="80" rx="5" ry="5" width="240" height="16" />
    <circle cx="19" cy="132" r="16" />
    <rect x="42" y="121" rx="5" ry="5" width="240" height="16" />
    <rect x="41" y="144" rx="5" ry="5" width="240" height="16" />
    <circle cx="342" cy="84" r="2" />
  </ContentLoader>
);
